import c from './status.module.scss';

const Status = ({ color, text, mode = 'canvas' }) => {
  return (
    <span className={[c.status, c[color], c[mode]].join(' ')}>{text}</span>
  );
};

export default Status;
